export default __webpack_public_path__ + "static/media/hero-img.92b05a70.svg";